/* eslint-disable import/prefer-default-export */
import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { getAttachmentBuckets } from "api/services/common";
import { AttachmentBucket } from "types/Common";
import { commonQueryKeys } from "./commonQueryKeys";

export function useGetAttachmentBuckets<T = AttachmentBucket[]>(
  paymentLocation: string,
  isQuickRequest: boolean = false,
  options?: UseQueryOptions<T>,
) {
  return useQuery<T>({
    queryKey: commonQueryKeys.attachmentBuckets(paymentLocation, isQuickRequest),
    queryFn: () =>
      getAttachmentBuckets(paymentLocation, { params: { ...(isQuickRequest && { source: "quick_request" }) } }).then(
        (res: any) => res.data.results,
      ),
    ...options,
  });
}
